import {
  parse_flight_offers_itinerary_carriers,
  is_adult,
} from '@liveflight/utilities/mixins';
import { parse_flight_offer_bags } from '@liveflight/utilities/flight-offer';
import { max } from 'mathjs';

export const carrier_iata = (itinerary, segment_index = 0) => {
  const index = itinerary.segments.length < segment_index ? segment_index : 0;
  return parse_flight_offers_itinerary_carriers(itinerary.segments)[index];
};

export const bags_quantity_color = (quantity = 0, active_color = '#39414E') =>
  quantity > 0 ? active_color : '#AAAAAA';

export const hand_bags_per_adult = (flight_offer) => {
  if (!flight_offer) {
    return 0;
  }
  return (flight_offer.travelerPricings || []).length > 0 ? 1 : 0;
};
export const luggage_bags_per_adult = (flight_offer, itinerary_index = 0) => {
  if (!flight_offer) {
    return 0;
  }
  const { travelers = [] } = parse_flight_offer_bags(flight_offer, itinerary_index);
  return travelers
    .filter((traveler) => is_adult(traveler))
    .reduce((included, traveler) => max(traveler.included || 0, included), 0);
};
